{
  "battery": "Batterie",
  "device": "Appareil",
  "depth": "Profundite",
  "flow": "Couler",
  "gps": "GPS",
  "hallSwitch": "Interrupteur à effet Hall",
  "hall_switch": "Interrupteur à effet Hall",
  "humidity": "Humidité",
  "icm": "Orientation",
  "pressure": "Pression",
  "pressureSwitch": "Interrupteur à pression",
  "pressure_switch": "Interrupteur à pression",
  "reel": "Bobine",
  "relay": "Relais",
  "temperature": "Température",
  "vfd": "Variateur de fréquence à variation continue",
  "wheel": "Roue"
}
